/**
 * 
 *  Angular Application Services.
 * 
 */

var forestServices = angular.module('forestServices', []);

forestServices.factory('Server', function($http, $q) {
    
    function typical (method, url, data, prepare) {
        var deferred = $q.defer();
        
        $http[method](url, data ? data : null).success(ok).error(fail);

        function ok(data){
            if(data && data.status == "OK"){

                if(prepare && data.data){
                    prepare(data);
                }

                deferred.resolve(data.data || "");
            } else {
                deferred.reject(data);
            }
        }

        function fail(res){
            deferred.reject(res);
        }
            
        return deferred.promise;
    }
    
    var Server = {

        getDropDownData : function () {
            return typical('get', '/api/dropdown-data');
        },

        getSbDropDownData : function () {
            return typical('get', '/api/sb-dropdown-data');
        },
        
        // PASSPORT
        
        getPassportData : function(id) {
            return typical('get', '/api/passports/'+ id +'/edit', null, function(responseData){
                
                var tmp;

                for (var key in responseData.data){
                    
                    //console.log("Parsing: ", key, responseData.data[key]);
                    
                    if(typeof responseData.data[key] == "string"){
                    //FIXME: Don't really trust this for some browsers
                        try{
                            tmp = JSON.parse(responseData.data[key]);
                        } catch (e){
                            //console.log("Error while parsing: ", key, responseData.data[key], e.message);
                            continue;
                        }
                        //if(key != "regioni" && key != "satyeo_ubani" && key != "satyeo_ubani"){
                            responseData.data[key] = tmp;
                        //} else {
                            //responseData.data[key] = undefined;
                       // }
                    }
                }
                
                //console.log('prepare run: ', responseData.data);
            });
        },
        createPassport : function(data, as_user){
            var url = '/api/passports/create' + (as_user ? '/' + as_user : '');

            return typical('post', url, data);
        },
        updatePassport : function(id, data){
            return typical('post', '/api/passports/'+ id +'/update', data);
        },
        deletePassport : function(id){
            return typical('get', '/api/passports/'+ id +'/delete');
        },
        getLatest : function(count){
            return typical('get', '/api/passports/latest/'+ count);
        },
        searchDocs : function(key){
            return typical('get', '/api/passports/search/'+ key);
        },
        getLatestClosed : function(count){
            return typical('get', '/api/passports/latest/'+ count +'/closed');
        },
        exportPassportDoc : function(id){
            
            location.href = '/api/passports/'+ id +'/doc';
            
        },

        /**
         * Create single passport dublicate optionally for specific user
         * @param id
         * @param as_user
         * @returns promise
         */
        createPassportDublicate : function(id, as_user){

            var defer = $q.defer();

            $q.all([
            /**
             * Load data from target forest cut.
             */
                this.getPassportData(id),
                this.getForma6Data(id),
                this.getTrees(id)
            ]).then(function(dataList){
                /**
                 * Create new passport from loaded data
                 * First passport and then forma6, forma1, just like created manually.
                 */
                Server.createPassport(dataList[0], as_user).then(function(res){
                    $q.all([
                        Server.updateForma6(res.created_id, dataList[1]),
                        Server.updateForma1(res.created_id, dataList[2])
                    ]).then(function(){
                        defer.resolve(res.created_id);
                    }).catch(function(){
                        defer.reject(false);
                    });
                });
            });

            return defer.promise;
        },

        /**
         * Create passport dublicates for specific user.
         * @param items
         * @param user_id
         * @returns promise
         */
        dublicatePassportsForUser : function(items, user_id){

            if(!items || !(items.length > 0) || !user_id){
                return;
            }

            return $q.all(_.map(items, function(value){

                return Server.createPassportDublicate(value, user_id);

            }));
        },
        /**
         *
         * Change owner/user of passport
         * @param id
         * @param new_user_id
         * @returns promise
         */
        updatePassportUser : function(id, new_user_id){
            return typical('get', '/api/passports/'+ id +'/update-user/' + new_user_id);
        },

        deletePassportMany : function(ids){

            var promises = [];

            _.each(ids, function(id){
                promises.push(Server.deletePassport(id));
            });

            return $q.all(promises);
        },
        
        //FORMA 6
        
        getForma6Data : function(id){
            return typical('get', '/api/forma6/'+ id +'/edit');
        },
        updateForma6 : function(id, data){
            return typical('post', '/api/forma6/'+ id +'/update', data);
        },
        deleteForma6 : function(id){
            return typical('get', '/api/forma6/'+ id +'/delete');
        },
        
        // SERVER ASSISTANCE IN CALCULATIONS
        
        getTreesTanrigi : function(){
            return typical('get', '/api/calcs/tanrigi');
        },
        
        //FORMA 1
        
        getTrees : function(id){
            return typical('get', '/api/forma1/'+ id + '/edit');
        },
        updateForma1 : function(id, data){
            return typical('put', '/api/forma1/'+ id, data);
        },
        deleteTrees : function(id){
            return typical('delete', '/api/trees/'+ id);
        },

        //Users

        getUserList : function(){
            return typical('get', '/api/users');
        },

        // Admin
        getXisSaxeobas : function(){
            return typical('get', '/api/xis-saxeobas');
        },

        getTanrigisCxriliSaxeobas : function(){
            return typical('get', '/api/tanrigis-cxrili-saxeobas');
        },

        syncChosenCalcTables : function(data){
            return typical('post', '/api/sync-calc-tables', data);
        },

        syncIsRed : function(data){
            return typical('post', '/api/sync-is-red', data);
        },

        getAssociatedList : function(){
            return typical('get', '/api/get-assoc-table-list');
        },

        getRedList : function(){
            return typical('get', '/api/get-red-list');
        },

        createNewSaxeoba : function(data){
            return typical('post', '/api/create-new-saxeoba', data);
        },

        deleteSaxeoba : function(id){
            return typical('get', '/api/saxeoba/'+ id +'/delete');
        },

        validatePassport : function(id){
            return typical('get', '/api/validate-passport/' + id );
        },

        /**
         * Sataqsacio barati
         */

        saveSb : function (data) {
            return typical('post', '/api/sb/create', data);
        },

        getSbKvartalis : function(satyeo_id){

            return typical('get', '/api/sb/kvartalis/' + satyeo_id);
        },

        getSbLiteris : function(satyeo_id, kvartali){

            return typical('get', '/api/sb/literis/' + satyeo_id + '/' + kvartali);
        },

        getSbData : function(satyeo_id, kvartali, literi){
            return typical('get', '/api/sb/edit/' + satyeo_id + '/' + kvartali + '/' + literi);
        },

        deleteSb : function(id){
            return typical('delete', '/api/sb/delete/' + id);
        },

        sbSyncChosenMaragiTables : function(data){
            return typical('post', '/api/sb/sync-maragi-tables', data);
        },

        sbSyncBonitetiTables : function(data){
            return typical('post', '/api/sb/sync-boniteti-tables', data);
        },

        sbSyncXnovanebaTables : function(data){
            return typical('post', '/api/sb/sync-xnovaneba-tables', data);
        },

        sbGetDrops : function(){
            return typical('get', '/api/sb/get-admin-drop-data');
        }
    };

    return Server;
});

forestServices.factory('Calc', function(){

    return {

        getMdgomareoba : function (sixshire_id, simagle_id, raodenoba) {
            console.log(sixshire_id, simagle_id, raodenoba);
            // [koromis sixshire][mozardis simagle]
            var table = [
                [7000, 7000, 4000, 4000, 4000, 4000, 2000],
                [7000, 7000, 4000, 4000, 4000, 4000, 2000],
                [7000, 7000, 4000, 4000, 4000, 4000, 2000],
                [7000, 7000, 4000, 4000, 4000, 4000, 2000],
                [4000, 4000, 2000, 2000, 2000, 2000, 1000],
                [4000, 4000, 2000, 2000, 2000, 2000, 1000],
                [1, 1, 1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1, 1, 1],
                [1, 1, 1, 1, 1, 1, 1]
            ];

            if (sixshire_id && simagle_id && raodenoba) {
                return table[sixshire_id - 1][simagle_id - 1]
                <= raodenoba ? 1 : 0;
            } else {
                return undefined;
            }
        }
    };

    return Server;
});

forestServices.factory('User', ['$http', '$q', '$rootScope', '$location', 
                                function($http, $q, $rootScope, $location) {
    return {
        getName : function(){
            return $rootScope.authed && $rootScope.authed.username ? $rootScope.authed.username : '';
        },
        isAdmin : function(){
            return $rootScope.authed && $rootScope.authed.role_id
                && $rootScope.authed.role_id == 1;
        },
        isAuthed: function(){

            var deferred = $q.defer();

            console.log('$rootScope.authed', $rootScope.authed);

            if($rootScope.authed){
                deferred.resolve(true);
            }else{
                //console.log("authed=FALSE checking on server side");
                
                $http({
                method: 'POST',
                url: '/api/isauthed',
                headers: {'Content-Type' : 'application/x-www-form-urlencoded'}})
                    .success(function (data) {
                        if(data['msg'] === "Yes"){
                            //alert("Good message redirect will happen right now");
                            $rootScope.authed = data['data'];
                            //$location.path("/");
                            deferred.resolve(data['data']);
                        }else{ 
                            deferred.reject();
                            //$location.path("/login");
                        }
                    })
                    .error(function () {
                        deferred.reject();
                        alert("Defered BAD rejected2");
                        //$location.path("/");
                    });
                
             }
            return deferred.promise;
            //alert("Check auth : " + $rootScope.authed);
        },
        login: function(loginData) {
          return $http({
              method: 'POST',
              url: '/api/login',
              headers: {'Content-Type' : 'application/x-www-form-urlencoded'},
              data: $.param(loginData)
            });
        },
        logout: function(){
            return $http({
              method: 'GET',
              url: '/api/logout'
            });
        }
    };
}]);

forestServices.factory('FormMaterials', ['$http', '$q', '$rootScope', '$location',
                                function($http, $q, $rootScope, $location) {
    return {

// Data generator functions for Dropdown menus, data generated from these functions
// are statically copy pasted in this service and are assigned to vareables. Reason is
// to avoid calling these function at each application initialization

      rangeArray: function(start, end, step){

        var ret = [];
        var id = 0;
        var inc = step ? step : 1;

        if(!(start || end)){
          return ret;
        }

        while(start <= end){
          ret.push({id: id, label: start});
          id++;
          start+=inc;
        }

        return ret;
      },

      rangeArrayLiters: function(start, end){

        var ret = [];
        var id = 1;

        if(!(start || end)){
          return ret;
        }

        ret.push({id: 0, label: "ყოფ. საკოლმეურნეო ტყე"});

        while(start <= end){
          ret.push({id: id, label: start});
          id++;
          ret.push({id: id, label: start + " ნაწ."});
          id++;
          start++;
        }

        return ret;
      },

      rangeArrayChrisProcenti: function(start, end){

        var ret = [];
        var id = 0;

        if(!(start || end)){
          return ret;
        }

        while(start <= end){
          ret.push({id: id, label: start});
          start += 5;
          id++;
        }

        return ret;
      },

      rangeArrayTyisSixshire: function(start, end){

        var ret = [];
        var id = 0;

        if(!(start || end)){
          return ret;
        }

        while(start <= end){
          ret.push({id: id, label: start.toFixed(1)});
          start += 0.1;
          id++;
        }

        return ret;
      },

      rangeArrayAgmonaceniSimagle: function(start, end){

        var ret = [];
        var id = 0;

        if(!(start || end)){
          return ret;
        }

        while(start <= end){
          ret.push({id: id, label: start.toFixed(1)});
          start += 0.5;
          id++;
        }

        ret.push({id: id, label: "3.1 და მეტი"});

        return ret;
      },

      arrayXnovaneba: function(start, end){
        /*return [
          {id: 0, label: 'ახალგაზრდა'},
          {id: 1, label: 'შუახნოვანი'},
          {id: 2, label: 'მომწიფარი'},
          {id: 3, label: 'მწიფე'},
          {id: 4, label: 'მწიფეზე უხნესი'}
        ];*/


      },

      arrayStep: function(start, end, step){
        var ret = [];
        var id = 0;

        if(!(start || end)){
          return ret;
        }

        while(start < end){
          ret.push({id: id, label: (id === 0 ? start : (start + 1)) + "-" + (start + step)});
          start += step;
          id++;
        }

        return ret;
      },

      arrayStepDaqaneba: function(start, end, step){
        var ret = [];
        var id = 0;

        if(!(start || end)){
          return ret;
        }

        while(start < end){
          ret.push({id: id, label: (id === 0 ? start : (start + 1)) + "-" + (start + step)});
          start += step;
          id++;
        }

        ret.push({id: id, label: "31 და მეტი"});

        return ret;
      },

      arrayExpozicia: function(){
        return [
          {id: 0, label: 'ჩ'},
          {id: 1, label: 'ჩ.დ'},
          {id: 2, label: 'ჩ.ა'},
          {id: 3, label: 'ს'},
          {id: 4, label: 'ს.დ'},
          {id: 5, label: 'ს.ა'},
          {id: 6, label: 'დ'},
          {id: 6, label: 'ა'}
        ];
      },

      arrayMozardAgmonaceni: function(){
        var ret = [];
        var id = 0;
        var end = 3;
        var start = .5;

        if(!(start || end)){
          return ret;
        }

        ret.push({id: id++, label: 'მოზარდ აღმონაცენი არ არის'});

        while(start <= end){
          ret.push({id: id++, label: start.toFixed(1)});
          start += 0.5;
        }

        ret.push({id: id, label: "3.1 და მეტი"});

        return ret;
      },

      arrayZona: function(){
        return[{id: 0, label: '37N'}, {id: 1, label: '38N'}];
      },

      arrayChrisSaxeebi: function(){
        return[{id: 0, label: 'მთავარი სარგებლობა (თანდათანობითი)'},
               {id: 1, label: 'მთავარი სარგებლობა (ნებითი-ამორჩევითი)'},
               {id: 2, label: 'მთავარი სარგებლობა (პირწმინდა)'},
               {id: 3, label: 'მთავარი სარგებლობა (ჯგუფურ-ამორჩევითი)'},
               {id: 4, label: 'მოვლითი ჭრა (გავლითი)'},
               {id: 5, label: 'მოვლითი ჭრა (გამოხშირვითი)'},
               {id: 6, label: 'მოვლითი ჭრა (განათებითი)'},
               {id: 7, label: 'მოვლითი ჭრა (გაწმენდითი)'},
               {id: 8, label: 'სააგენტოს მიერ განხორციელებული სპეციალური ჭრა'},
               {id: 9, label: 'სანიტარული ჭრა'},
               {id: 10, label: 'სარეკონსტრუქციო ჭრა'},
               {id: 11, label: 'სოციალური ჭრა'},
               {id: 12, label: 'სოციალური ჭრა მთავრობის განკარგულებით'},
               {id: 13, label: 'სპეციალური ჭრა'},
               {id: 14, label: 'ძირნაყარი ხე-ტყე'}];
      }

    };
}]);

forestServices.factory('Settings', function($resource){
    return $resource('/api/settings');
});
